const PREFIX = "/order_list/";
export const ADD_ORDER_LIST_REFERENCES_URL = PREFIX + "add-order-list-references";
export const UPLOAD_ORDER_LIST_REFERENCES_FILE_URL = PREFIX + "upload/references-file";
